import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

function loadAnalytics(id) {
  if (!id || !/^G-[A-Z0-9]+$/.test(id) || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}

export function SiteProvider({ children }) {
  const [state, setState] = useState({ site: null, services: [], faqs: [], pages: [], loading: true, error: null });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const [site, services, faqs, pages] = await Promise.all([api.get("/public/site"), api.get("/public/services"), api.get("/public/faqs"), api.get("/public/pages")]);
      setState({ site: site.data, services: services.data, faqs: faqs.data, pages: pages.data, loading: false, error: null });
      loadAnalytics(site.data.seo?.ga_measurement_id);
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: "We couldn't load the latest content." }));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <SiteContext.Provider value={{ ...state, reload: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
